export default __webpack_public_path__ + "images/gears.3875480b3816208106cfa442bb822917.svg";